angular.module('Directives')
    .directive('bbaLocationPicker', bbaLocationInput);

function bbaLocationInput(Location, aborter) {
    return {
        restrict: 'E',
        replace: true,
        require: '^form',
        templateUrl: '/templates/directives/bbaLocationPicker.html',
        scope: {
            ngModel: '=',
            ngDisabled: '=?',
            ngChange: '&?',
            type: '@?',
            isRequired: '=?'
        },
        link: bbaLocationInputCtrl
    }
    function bbaLocationInputCtrl($scope, $element, $attrs, ngForm) {
        var occurrences = $('form[name="' + $attrs.fromForm + '"] .bba-location-picker').length;
        $scope.occurances = occurrences;
        $scope.fromForm = ngForm;
        $scope.testAffix = $attrs.fromForm;
        $scope.display = {};
        $scope.suburbs = [];
        $scope.isTooltipEnabled = false;
        $scope.isRequired = $scope.isRequired === undefined ? true : $scope.isRequired;
        $scope.$watch('ngModel', function (newVal) {
            if (newVal) {
                if (newVal.country) {
                    $scope.display.country = newVal.country;
                }
                if (newVal.id) {
                    $scope.display.complete = newVal;
                }else{
                    $scope.display.complete = null;
                }
            } else if ($scope.display) {
                delete $scope.display.country;
                delete $scope.display.complete;
            }
            if($scope.ngChange)
                $scope.ngChange({'temp':'temp'});
        });

        if (occurrences > 1) {
            $scope.countryName = 'country' + occurrences;
            $scope.postcodeName = 'postcode' + occurrences;
            $scope.suburb = 'suburb' + occurrences;
        } else {
            $scope.countryName = 'country';
            $scope.postcodeName = 'postcode';
            $scope.suburb = 'suburb';
        }

        $scope.isCountryValid = isCountryValid;
        $scope.isPostcodeValid = isPostcodeValid;
        $scope.selectCountry = selectCountry;
        $scope.selectPostCode = selectPostCode;
        $scope.searchForZipcode = searchForZipcode;
        $scope.buildStates = buildStates;
        $scope.initSuburbs = initSuburbs;
        function isCountryValid() {
            if ($scope.fromForm[$scope.countryName]) {
                return ($scope.fromForm[$scope.countryName].$invalid && $scope.fromForm[$scope.countryName].$touched) || ($scope.fromForm[$scope.countryName].$invalid && $scope.fromForm.$submitted);
            }
            else {
                return false;
            }
        }
        function selectCountry(item, model) {
            if ($scope.display && $scope.display.complete)
                delete $scope.display.complete;
            $scope.ngModel = {
                country: item
            };
            $scope.postCodes = [];
        };
        function searchForZipcode(country, select, size = 2000) {
            if(select.open){
                $scope.searching = [];
                $scope.postCodes = [];
                aborter(()=>{
                    $scope.searching.push(true);
                    Location.ZipCode({
                        country: country ? country.code : angular.getObjVal($scope, 'display.complete.country.code'),
                        size: size,
                        sort: 'code',
                        code: select.search
                    }, function (data) {
                        $scope.searching.pop();
                        if(!$scope.searching.length){
                            $scope.postCodes = buildStates(data.content);
                        }
                    }, function (err) {
                        $scope.searching.pop();
                    })
                },500);
            }
        }
        function initSuburbs(country, select) {
            if(angular.isDefined(country)){
                if(!select.open){
                    Location.ZipCode({
                        country: country.country ?
                            country.code : angular.getObjVal($scope, 'display.complete.country.code'),
                        size: 10,
                        sort: 'code',
                        code: select.search || angular.getObjVal($scope, 'display.complete.code') || ''
                    }, function (data) {
                        $scope.postCodes = buildStates(data.content);
                        $scope.selectedCode = $scope.postCodes.find(postcode=>{
                            return postcode.code===angular.getObjVal($scope, 'display.complete.code');
                        });
                        $scope.suburbs = angular.copy($scope.selectedCode.altStates);
                    }, function (err) {
                    })
                }
            }
        }
        function buildStates(codes) {
            var distinctCodes = [];
            angular.forEach(codes, function (code, key) {

                if (codes[key - 1] && code.code == codes[key - 1].code) {
                    distinctCodes[distinctCodes.length - 1].altStates.push(angular.copy(code));
                } else {
                    code.altStates = [angular.copy(code)];
                    distinctCodes.push(angular.copy(code));
                }
            });
            return distinctCodes;
        };

        function selectPostCode(item, model) {
            if (item.id) {
                $scope.ngModel = item;
                $scope.suburbs = item.altStates;
            } else {
                model = null;
            }
        }

        function isPostcodeValid() {
            if ($scope.fromForm[$scope.postcodeName]) {
                return ($scope.fromForm[$scope.postcodeName].$invalid && $scope.fromForm[$scope.postcodeName].$touched) || ($scope.fromForm[$scope.postcodeName].$invalid && $scope.fromForm.$submitted);
            }
            else {
                return false;
            }
        };
        (function () {
            Location.Country({
                // name: model
            }, function (data) {
                $scope.countries = data;
                if (data.length <= 0)
                    $scope.countries = [{
                        name: 'No Search Result'
                    }];
            }, function (err) {
                $scope.countries = [{
                    name: 'No Search Result'
                }];
            })
        })();
    };
};




// WEBPACK FOOTER //
// ./js/directives/bbaLocationPicker.js